<div class="mt-5 ">
    <div class="flex justify-content-between ">
        <div>
            <p-iconField iconPosition="right">
                <p-inputIcon styleClass="pi pi-search" />
                <input class="shadow-4" type="text" [(ngModel)]="milestoneSearchTerm" pInputText
                    placeholder="{{'search_by_stage_name'|translate}}" />
            </p-iconField>
        </div>
        <div class="flex gap-3">
            <p-button *ngIf="'manage_milestone' | able: 'Project': user: project"
                (onClick)="isMilestoneModalVisable=true" label="{{'new_milestone'|translate}}" [outlined]="true" />

            @if(user.strategy_admin&& project.assessment_status=='approved'){
            <p-button (onClick)="openAssessmentSidebar()" label=" {{'output_assessment'|translate}}"
                [outlined]="true" />
            }
        </div>
    </div>
    <div class="mt-5 w-full">
        <p-table dataKey="id" styleClass="w-full" #table [class]="dir" [dir]="dir" [value]="filteredMilestones"
            [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5, 10, 20]" [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>

                    </th>
                    <th>
                        {{'milestone' | translate}}
                    </th>
                    <th>
                        {{'description' | translate}}
                    </th>

                    <th>
                        {{'outputs' | translate}}
                    </th>
                    <th>
                        {{'implementation_period' | translate}}
                    </th>
                    <th>
                        {{'milestone_kpi' | translate}}
                    </th>
                    <!-- 
                    <th *ngIf="project.assessment_status == 'approved' && !project.is_on_hold">
                        {{'progress_status' | translate}}
                    </th>
                    <th *ngIf="project.assessment_status == 'approved' && !project.is_on_hold">
                        {{'approval_status' | translate}}
                    </th> -->

                    <th>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-milestone let-expanded="expanded">
                <tr class="cursor-pointer">
                    <td>

                        <p-button (click)="expanded ? table.toggleRow(milestone) : table.toggleRow(milestone)"
                            type="button" pRipple [pRowToggler]="project" [text]="true" [rounded]="true" [plain]="true"
                            [icon]="expanded ? 'pi pi-chevron-up':'pi pi-chevron-down'" />
                    </td>
                    <td>
                        <span class="font-bold">

                            {{milestone.name}}
                        </span>
                        <!-- {{milestone|json}} -->
                    </td>
                    <td>

                        <span pTooltip="{{milestone.description}}" tooltipPosition="top"
                            class="text-black text-xs font-bold">{{milestone.description|substring:50}}

                        </span>
                    </td>
                    <td>

                        <span pTooltip="{{milestone.outputs}}" tooltipPosition="top"
                            class="text-black text-xs font-bold">{{milestone.outputs|substring:50}}
                        </span>

                    </td>
                    <td>
                        <div class="mb-2" style="min-width: 10rem;">
                            <span class="font-semibold">من:</span> {{milestone.start_date|date}}

                        </div>
                        <div style="min-width: 10rem;">
                            <span class="font-semibold">الي:</span> {{milestone.end_date|date}}

                        </div>

                    </td>
                    <td>
                        {{milestone.indicator_name}}
                    </td>
                    <!-- <td *ngIf="project.assessment_status == 'approved' && !project.is_on_hold">
                        @switch (milestone.progress_status)
                        {

                        @case ('not_started') {
                        <p-tag severity="info" value="{{milestoneStatusValues['not_started']}}" />
                        }
                        @case ('in_progress') {
                        <p-tag severity="warning" value="{{milestoneStatusValues['in_progress']}}" />
                        }
                        @case ('completed') {
                        <p-tag severity="success" value="{{milestoneStatusValues['completed']}}" />
                        }
                        @case ('on_hold') {
                        <p-tag severity="warning" value="{{milestoneStatusValues['on_hold']}}" />
                        }


                        }



                    </td>
                    <td *ngIf="project.assessment_status == 'approved' && !project.is_on_hold">
                        @switch (milestone.approval_status)
                        {

                        @case ('approved') {
                        <p-tag severity="success" value="{{milestoneStatusValues['approved']}}" />
                        }
                        @case ('pending') {
                        <p-tag severity="warning" value="{{milestoneStatusValues['pending']}}" />
                        }
                        @case ('rejected') {
                        <p-tag severity="danger" value="{{milestoneStatusValues['rejected']}}" />
                        }
                        @case ('awaiting_upload') {
                        <p-tag severity="info" value="{{milestoneStatusValues['awaiting_upload']}}" />
                        }

                        }
                    </td> -->
                    <td>
                        <div class="flex justify-content-center align-items-center gap-2">

                            <div *ngIf="project.assessment_status == 'draft'" (click)="addNewMilstone(milestone.id)"
                                pTooltip="{{'Add Activity'|translate}}"
                                class="w-15 h-15 cursor-pointer border-round bg-green-500 flex align-items-center justify-content-center" tooltipPosition="left"
                                showDelay="500">
                                <i class="fa-solid fa-plus text-white "></i>
                            </div>
                            
                            <div *ngIf="'manage_milestone' | able:  'Project': user: project" tooltipPosition="top"
                                class="mx-1" [pTooltip]="updateMileStoneToolTip" showDelay="500" hideDelay="300"
                                (click)="openUpdatMileStoneModal(milestone.id, null)"
                                class="update__icon cursor-pointer">
                                <svg width="27" height="27" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16.4768 3.004C16.6438 3.019 16.7168 3.223 16.5968 3.342L8.27682 11.662C8.18283 11.756 8.11553 11.8734 8.08182 12.002L7.08182 15.832C7.04881 15.9586 7.04948 16.0916 7.08375 16.2178C7.11803 16.344 7.18472 16.4591 7.27721 16.5516C7.36971 16.6441 7.48478 16.7108 7.61101 16.7451C7.73725 16.7793 7.87025 16.78 7.99682 16.747L11.8258 15.747C11.9545 15.713 12.0719 15.6453 12.1658 15.551L20.6038 7.113C20.6302 7.0859 20.6638 7.06693 20.7007 7.05833C20.7375 7.04974 20.7761 7.05188 20.8117 7.06451C20.8474 7.07713 20.8787 7.09971 20.9019 7.12957C20.9252 7.15943 20.9394 7.19532 20.9428 7.233C21.2939 10.5826 21.2738 13.9608 20.8828 17.306C20.6598 19.211 19.1288 20.706 17.2308 20.919C13.7545 21.3044 10.2462 21.3044 6.76982 20.919C4.87082 20.706 3.33982 19.211 3.11682 17.306C2.70455 13.781 2.70455 10.22 3.11682 6.695C3.33982 4.789 4.87082 3.294 6.76982 3.082C9.99434 2.72466 13.247 2.69852 16.4768 3.004Z"
                                        fill="#0A9B4D" />
                                    <path
                                        d="M17.8231 4.237C17.8463 4.21372 17.8739 4.19525 17.9043 4.18264C17.9347 4.17004 17.9672 4.16355 18.0001 4.16355C18.033 4.16355 18.0656 4.17004 18.0959 4.18264C18.1263 4.19525 18.1539 4.21372 18.1771 4.237L19.5911 5.652C19.6378 5.69886 19.6641 5.76233 19.6641 5.8285C19.6641 5.89467 19.6378 5.95814 19.5911 6.005L11.2981 14.3C11.2665 14.3313 11.2272 14.3537 11.1841 14.365L9.27012 14.865C9.22793 14.876 9.1836 14.8758 9.14152 14.8644C9.09944 14.8529 9.06109 14.8307 9.03025 14.7999C8.99942 14.769 8.97719 14.7307 8.96577 14.6886C8.95434 14.6465 8.95412 14.6022 8.96512 14.56L9.46512 12.646C9.47625 12.6029 9.49869 12.5635 9.53012 12.532L17.8231 4.237Z"
                                        fill="#0A9B4D" />
                                </svg>
                            </div>
                            
                            <div *ngIf="'manage_milestone' | able:  'Project': user: project"
                                (click)="confirmMileStoneDelete($event,milestone.id)"
                                [pTooltip]="deleteMileStoneToolTip" tooltipPosition="left" showDelay="500"
                                hideDelay="300"
                                class="text-red-600 text-2xl flex cursor-pointer text-lg font-bold">
                                <i class="fa-regular fa-trash-can"></i>
                            </div>
                        </div>
                    </td>

                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-milestone>
                <tr>
                    <td colspan="10">
                        <div class="p-3">
                            <p-table [value]="milestone.subMilestones" dataKey="parent_milestone_id">
                                <ng-template pTemplate="header">
                <tr>

                    <th>
                        {{'milestone_activity' | translate}}
                    </th>
                    <th>
                        {{'description' | translate}}
                    </th>

                    <th>
                        {{'outputs' | translate}}
                    </th>
                    <th>
                        {{'implementation_period' | translate}}
                    </th>
                    <th>
                        {{'milestone_kpi' | translate}}
                    </th>
                    <th>
                        {{'execution_responsibility' | translate}}
                    </th>
                    <th>
                        {{'actual_completion_date' | translate}}
                    </th>
                    <th>
                        {{'estimated_cost' | translate}}
                    </th>
                    <th>
                        {{'completion_percentage' | translate}}
                    </th>
                    <th>
                        {{'completion_status' | translate}}
                    </th>

                    <th *ngIf="project.assessment_status == 'approved' && !project.is_on_hold">
                        {{'progress_status' | translate}}
                    </th>
                    <th *ngIf="project.assessment_status == 'approved' && !project.is_on_hold">
                        {{'approval_status' | translate}}
                    </th>
                    <th>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-activity>
                <tr class="cursor-pointer">
                    <td>
                        {{activity.name}}
                    </td>
                    <td>


                        <span pTooltip="{{activity.description}}" tooltipPosition="top"
                            class="text-black text-xs font-bold">{{activity.description|substring:20}}

                        </span>
                    </td>
                    <td>
                        <span pTooltip="{{milestone.outputs}}" tooltipPosition="top"
                            class="text-black text-xs font-bold">{{milestone.outputs|substring:50}}
                        </span>
                    </td>
                    <td>
                        <div class="mb-2" style="min-width: 10rem;">
                            <span class="font-semibold">من:</span> {{activity.start_date|date}}
                        </div>
                        <div style="min-width: 10rem;">
                            <span class="font-semibold">الي:</span> {{activity.end_date|date}}
                        </div>
                    </td>
                    <td>
                        {{activity.indicator_name}}
                    </td>
                    <td>
                        {{activity.execution_responsibility || '-'}}
                    </td>
                    <td>
                        {{activity.actual_completion_date ? (activity.actual_completion_date | date) : '-'}}
                    </td>
                    <td>
                        {{activity.estimated_cost ? activity.estimated_cost : '-'}}
                    </td>
                    <td>
                        {{activity.completion_percentage !== null && activity.completion_percentage !== undefined ? activity.completion_percentage + '%' : '-'}}
                    </td>
                    <td>
                        {{getCompletionStatusLabel(activity.completion_status)}}
                    </td>
                    <td *ngIf="project.assessment_status == 'approved' && !project.is_on_hold">

                        @switch (activity.progress_status)
                        {

                        @case ('not_started') {
                        <p-tag severity="info" value="{{milestoneStatusValues['not_started']}}" />
                        }
                        @case ('in_progress') {
                        <p-tag severity="warning" value="{{milestoneStatusValues['in_progress']}}" />
                        }
                        @case ('completed') {
                        <p-tag severity="success" value="{{milestoneStatusValues['completed']}}" />
                        }
                        @case ('on_hold') {
                        <p-tag severity="warning" value="{{milestoneStatusValues['on_hold']}}" />
                        }
                        }
                    </td>
                    <td *ngIf="project.assessment_status == 'approved' && !project.is_on_hold">
                        @switch (milestone.approval_status)
                        {

                        @case ('approved') {
                        <p-tag severity="success" value="{{milestoneStatusValues['approved']}}" />
                        }
                        @case ('pending') {
                        <p-tag severity="warning" value="{{milestoneStatusValues['pending']}}" />
                        }
                        @case ('rejected') {
                        <p-tag severity="danger" value="{{milestoneStatusValues['rejected']}}" />
                        }
                        @case ('awaiting_upload') {
                        <p-tag severity="info" value="{{milestoneStatusValues['awaiting_upload']}}" />
                        }

                        }
                    </td>
                    <td>
                        <div class="flex justify-content-evenly align-items-center">
                            <div class="flex flex-column gap-2 ">
                                @if(milestone.is_allowed_to_upload){
                                <button (click)="openUploadoutputModal(activity.id,activity.parent_milestone_id)"
                                    pButton class="p-1 w-12">
                                    <div class="flex align-items-center gap-2">
                                        <i class="fa-solid fa-upload"></i>
                                        <span>
                                            {{'attach_output'|translate}}
                                        </span>
                                    </div>
                                </button>
                                }
                                <button pButton *ngIf="project.assessment_status == 'approved'" class="p-1 w-12"
                                    (click)="openListOutPutModal(activity.id,activity.parent_milestone_id)">
                                    <div class="flex align-items-center gap-2">
                                        <i class="fa-regular fa-folder-open"></i>
                                        <span>
                                            {{'view_output'|translate}}
                                        </span>
                                    </div>
                                </button>
                            </div>
                            <div class="flex align-items-center gap-2">
                                <div *ngIf="'manage_milestone' | able:  'Project': user: project" tooltipPosition="top"
                                    class="mx-1" [pTooltip]="updateMileStoneToolTip" showDelay="500" hideDelay="300"
                                    (click)="openUpdatMileStoneModal(activity.id,activity.parent_milestone_id)"
                                    class="update__icon cursor-pointer">
                                    <!-- activity.id: {{activity.id|json}} -->
                                    <svg width="27" height="27" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.4768 3.004C16.6438 3.019 16.7168 3.223 16.5968 3.342L8.27682 11.662C8.18283 11.756 8.11553 11.8734 8.08182 12.002L7.08182 15.832C7.04881 15.9586 7.04948 16.0916 7.08375 16.2178C7.11803 16.344 7.18472 16.4591 7.27721 16.5516C7.36971 16.6441 7.48478 16.7108 7.61101 16.7451C7.73725 16.7793 7.87025 16.78 7.99682 16.747L11.8258 15.747C11.9545 15.713 12.0719 15.6453 12.1658 15.551L20.6038 7.113C20.6302 7.0859 20.6638 7.06693 20.7007 7.05833C20.7375 7.04974 20.7761 7.05188 20.8117 7.06451C20.8474 7.07713 20.8787 7.09971 20.9019 7.12957C20.9252 7.15943 20.9394 7.19532 20.9428 7.233C21.2939 10.5826 21.2738 13.9608 20.8828 17.306C20.6598 19.211 19.1288 20.706 17.2308 20.919C13.7545 21.3044 10.2462 21.3044 6.76982 20.919C4.87082 20.706 3.33982 19.211 3.11682 17.306C2.70455 13.781 2.70455 10.22 3.11682 6.695C3.33982 4.789 4.87082 3.294 6.76982 3.082C9.99434 2.72466 13.247 2.69852 16.4768 3.004Z"
                                            fill="#0A9B4D" />
                                        <path
                                            d="M17.8231 4.237C17.8463 4.21372 17.8739 4.19525 17.9043 4.18264C17.9347 4.17004 17.9672 4.16355 18.0001 4.16355C18.033 4.16355 18.0656 4.17004 18.0959 4.18264C18.1263 4.19525 18.1539 4.21372 18.1771 4.237L19.5911 5.652C19.6378 5.69886 19.6641 5.76233 19.6641 5.8285C19.6641 5.89467 19.6378 5.95814 19.5911 6.005L11.2981 14.3C11.2665 14.3313 11.2272 14.3537 11.1841 14.365L9.27012 14.865C9.22793 14.876 9.1836 14.8758 9.14152 14.8644C9.09944 14.8529 9.06109 14.8307 9.03025 14.7999C8.99942 14.769 8.97719 14.7307 8.96577 14.6886C8.95434 14.6465 8.95412 14.6022 8.96512 14.56L9.46512 12.646C9.47625 12.6029 9.49869 12.5635 9.53012 12.532L17.8231 4.237Z"
                                            fill="#0A9B4D" />
                                    </svg>
                                </div>
                                <div *ngIf="'manage_milestone' | able:  'Project': user: project"
                                    (click)="confirmMileStoneDelete($event,activity.id)"
                                    [pTooltip]="deleteMileStoneToolTip" tooltipPosition="left" showDelay="500"
                                    hideDelay="300"
                                    class="text-red-600 text-2xl flex cursor-pointer text-lg font-bold">
                                    <i class="fa-regular fa-trash-can"></i>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>

            </ng-template>

        </p-table>
    </div>
    </td>
    </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-c>
        <tr>
            <td class="text-center font-bold text-lg m-3" [attr.colspan]="10" [attr.rowspan]="3">
                <i class="fa-solid fa-circle-exclamation"></i>
                {{'define_implementation_milestones' | translate}}
            </td>
        </tr>
    </ng-template>
    </p-table>
</div>

<div>
    <form #extraForm="ngForm" (ngSubmit)="submit()">
        <div class="mt-3">
            <div class="mb-3 g-c-primaryDarkColor font-bold">
                <label>{{'expected_positive_impacts_of_the_initiative' | translate }}</label>
            </div>
            <textarea #positive_effects="ngModel" ngModel name="positive_effects" rows="5" cols="30"
                pInputTextarea></textarea>
        </div>
        <div class="my-3">
            <div class="mb-3 g-c-primaryDarkColor font-bold">
                <label>{{'supporting_models_and_studies_for_the_initiative' | translate }}</label>
            </div>
            <textarea #supporting_models_studies="ngModel" ngModel name="supporting_models_studies" rows="5" cols="30"
                pInputTextarea></textarea>

        </div>

        <p-button type="submit" label=" حفظ الاثار والنماذج" icon="pi pi-check" />

    </form>

</div>
</div>

@if (assessmentSidebarVisible) {

<div [@toggleWidth]="isOpen ? 'open' : 'closed'"
    class="h-screen pt-8  px-4 bg-white shadow-3  right-0 fixed  top-0  z-50" style="z-index: 90000;">
    <div class="pt-2 flex justify-content-between">
        <div></div>
        <div (click)="closeAssessmentSidebarVisible()"
            class="w-2rem h-2rem bg-red-500 cursor-pointer  shadow-3 hover:bg-red-800   border-circle flex justify-content-center align-items-center">
            <i class="fa-solid fa-xmark text-white  "></i>
        </div>
    </div>
    <div style="overflow-y: auto; max-height: calc(100vh - 10rem);">
        <app-project-file-auditor (onFileReviewed)="onFileReviewed($event)" [projectId]="projectId"
            [selectedStrategyId]="strategyId"></app-project-file-auditor>
    </div>
</div>
}
@if(isMilestoneModalVisable){
<div class="g-modal  mileStoneModal">
    <div class="flex  justify-content-between align-items-center flex-row-reverse ">
        <div (click)="closeMileStoneModal()"
            class="  bg-red-500 g-c-white cursor-pointer  w-3rem p-1 shadow-4 text-center  font-bold text-xl  bg-secondary-color border-round">
            <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="titel font-bold g-c-primaryDarkerColor g-c-primaryDarkerColor">
            {{'new_milestone'|translate}}
        </div>
    </div>
    <div class="br">
    </div>

    <div class="modal__body">
        <form #MileStoneForm="ngForm" (ngSubmit)="submitMileStone()">
            <!-- القسم الأول: البيانات الأساسية -->
            <div class="form-section">
                <h3 class="section-title">{{'basic_data' | translate}}</h3>
                
                <!-- سطر 1: اسم المرحلة + مؤشر أداء المرحلة -->
                <div class="grid">
                    <div class="lg:col-6 md:col-12 col-12">
                        <div class="field-wrapper">
                            <label class="field-label required">{{'milestone_name'|translate}}</label>
                            <input required [(ngModel)]="selectedMileStone.name" name="name" #name="ngModel" ngModel
                                type="text" pInputText class="w-full" />
                            @if((name.invalid && !name.pristine)||(isSubmittedMileStone&&name.invalid)){
                            <div class="field-error">
                                <span class="text-red-500">{{'field_is_required'|translate}}</span>
                            </div>
                            }
                        </div>
                    </div>
                    <div class="lg:col-6 md:col-12 col-12">
                        <div class="field-wrapper">
                            <label class="field-label required">{{'milestone_kpi'|translate}}</label>
                            <input required [(ngModel)]="selectedMileStone.indicator_name" name="indicator_name"
                                #indicator_name="ngModel" ngModel type="text" pInputText class="w-full" />
                            @if((indicator_name.invalid && !indicator_name.pristine)||(isSubmittedMileStone&&indicator_name.invalid)){
                            <div class="field-error">
                                <span class="text-red-500">{{'field_is_required'|translate}}</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <!-- سطر 2: الخطوات التفصيلية + المخرجات المتوقعة -->
                <div class="grid mt-3">
                    <div class="lg:col-6 md:col-12 col-12">
                        <div class="field-wrapper">
                            <label class="field-label required">{{'detailed_steps'|translate}}</label>
                            <textarea required [(ngModel)]="selectedMileStone.description" #description="ngModel" 
                                name="description" rows="3" pInputTextarea class="w-full"></textarea>
                            @if((description.invalid && !description.pristine)||(isSubmittedMileStone&&description.invalid)){
                            <div class="field-error">
                                <span class="text-red-500">{{'field_is_required'|translate}}</span>
                            </div>
                            }
                        </div>
                    </div>
                    <div class="lg:col-6 md:col-12 col-12">
                        <div class="field-wrapper">
                            <label class="field-label required">{{'expected_outputs'|translate}}</label>
                            <textarea required [(ngModel)]="selectedMileStone.outputs" #outputs="ngModel" 
                                name="outputs" rows="3" pInputTextarea class="w-full"></textarea>
                            @if((outputs.invalid && !outputs.pristine)||(isSubmittedMileStone&&outputs.invalid)){
                            <div class="field-error">
                                <span class="text-red-500">{{'field_is_required'|translate}}</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <!-- القسم الثاني: التواريخ -->
            <div class="form-section mt-4">
                <h3 class="section-title">{{'implementation_period' | translate}}</h3>
                
                <!-- سطر 3: التاريخ المخطط للتنفيذ (من) + التاريخ المخطط للتنفيذ (إلى) -->
                <form #dateForm="ngForm" appDateRangeValidator
                    [dateRange]="{ startDate: 'start_date', endDate: 'end_date' }">
                    <div class="grid">
                        <div class="lg:col-6 md:col-12 col-12">
                            <div class="field-wrapper">
                                <label class="field-label required">{{'planned_start_date' | translate}}</label>
                                <p-calendar required appendTo="body" [(ngModel)]="selectedMileStone.start_date"
                                    #start_date="ngModel" name="start_date" [iconDisplay]="'input'" [showIcon]="true"
                                    inputId="start_date" class="w-full" />
                                @if((start_date.invalid && !start_date.pristine)||(isSubmittedMileStone&&start_date.invalid)){
                                <div class="field-error">
                                    <span class="text-red-500">{{'field_is_required'|translate}}</span>
                                </div>
                                }
                            </div>
                        </div>
                        <div class="lg:col-6 md:col-12 col-12">
                            <div class="field-wrapper">
                                <label class="field-label required">{{'planned_end_date' | translate}}</label>
                                <p-calendar appendTo="body" required [(ngModel)]="selectedMileStone.end_date"
                                    #end_date="ngModel" name="end_date" [iconDisplay]="'input'" [showIcon]="true"
                                    inputId="end_date" class="w-full" />
                                @if((end_date.invalid && !end_date.pristine)||(isSubmittedMileStone&&end_date.invalid)){
                                <div class="field-error">
                                    <span class="text-red-500">{{'field_is_required'|translate}}</span>
                                </div>
                                }
                                @if(dateForm.errors?.['dateRangeInvalid']){
                                <div class="field-error">
                                    <span class="text-red-500">{{'date_range_validation'|translate}}</span>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <!-- القسم الثالث: بيانات التنفيذ -->
            <div class="form-section mt-4">
                <h3 class="section-title">{{'execution_data' | translate}}</h3>
                
                <!-- سطر 4: مسؤولية التنفيذ + التاريخ الفعلي للانتهاء -->
                <div class="grid">
                    <div class="lg:col-6 md:col-12 col-12">
                        <div class="field-wrapper">
                            <label class="field-label">{{'execution_responsibility' | translate}}</label>
                            <input [(ngModel)]="selectedMileStone.execution_responsibility" 
                                name="execution_responsibility" type="text" pInputText 
                                [placeholder]="dir == 'rtl' ? 'أدخل مسؤول التنفيذ' : 'Enter Execution Responsible'"
                                class="w-full" />
                        </div>
                    </div>
                    <div class="lg:col-6 md:col-12 col-12">
                        <div class="field-wrapper">
                            <label class="field-label">{{'actual_completion_date' | translate}}</label>
                            <p-calendar appendTo="body" [(ngModel)]="selectedMileStone.actual_completion_date"
                                name="actual_completion_date" [iconDisplay]="'input'" [showIcon]="true"
                                inputId="actual_completion_date" [showClear]="true" class="w-full" />
                        </div>
                    </div>
                </div>

                <!-- سطر 5: حالة الإنجاز (في سطر منفصل) -->
                <div class="grid mt-3">
                    <div class="lg:col-6 md:col-12 col-12">
                        <div class="field-wrapper">
                            <label class="field-label">{{'completion_status' | translate}}</label>
                            <p-dropdown [(ngModel)]="selectedMileStone.completion_status" name="completion_status"
                                [options]="completionStatusOptions" optionLabel="label" optionValue="value" 
                                [placeholder]="dir == 'rtl' ? 'حالة الإنجاز' : 'Completion Status'"
                                [showClear]="true" class="w-full" />
                        </div>
                    </div>
                </div>

                <!-- سطر 6: التكلفة التقديرية + نسبة الإنجاز -->
                <div class="grid mt-3">
                    <div class="lg:col-6 md:col-12 col-12">
                        <div class="field-wrapper">
                            <label class="field-label">{{'estimated_cost' | translate}}</label>
                            <p-inputNumber [(ngModel)]="selectedMileStone.estimated_cost" name="estimated_cost"
                                [showButtons]="true" [min]="0" [maxFractionDigits]="2" 
                                [placeholder]="dir == 'rtl' ? 'التكلفة التقديرية' : 'Estimated Cost'"
                                class="w-full" />
                        </div>
                    </div>
                    <div class="lg:col-6 md:col-12 col-12">
                        <div class="field-wrapper">
                            <label class="field-label">{{'completion_percentage' | translate}}</label>
                            <p-inputNumber [(ngModel)]="selectedMileStone.completion_percentage" 
                                name="completion_percentage" [showButtons]="true" [min]="0" [max]="100" 
                                [placeholder]="dir == 'rtl' ? 'نسبة الإنجاز' : 'Completion Percentage'"
                                class="w-full" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <p-button [disabled]="MileStoneForm.invalid||dateForm.invalid" label="{{'save' | translate}}"
                    type="submit" [raised]="true" />
            </div>
        </form>
    </div>
</div>
<div class="g-overlay"></div>
}
@if(isUploadoutputModalVisable){
<div class="g-modal">
    <div class="flex  justify-content-between align-items-center flex-row-reverse ">
        <div (click)="closeUploadoutputModal()"
            class="  bg-red-500 g-c-white cursor-pointer  w-3rem p-1 shadow-4 text-center  font-bold text-xl  bg-secondary-color border-round">
            <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="titel font-bold g-c-primaryDarkerColor g-c-primaryDarkerColor">
            {{'attach_output'|translate}}
        </div>
    </div>
    <div class="br">
    </div>

    <div class="modal__body">
        <form>

            <div class="flex align-items-center flex-wrap">
                <div class="flex flex-column gap-3    align-items-center   justify-content-center   mx-auto">
                    <div (click)="triggerFileInput()"
                        class="text-2xl mt-3    w-6rem text-center cursor-pointer g-c-primaryDarkColor border-round-lg  border-2 py-2">
                        <i class="fa-solid fa-upload "></i>


                        <input type="file" multiple (change)="onFileChange($event)" hidden #fileInput id="file" ngModel
                            #file="ngModel" name="file" required>
                    </div>
                    <div>
                        @if(uploadedFilesCount){
                        <p-table [ngClass]="dir" [value]="filesMetaData" class="w-12">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th></th>
                                    <th>{{'file_name'|translate}}
                                    </th>

                                    <th class="text-center"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-file let-i="rowIndex">
                                @if(!file.is_deleted){
                                <tr>
                                    <td>
                                        <i [class]="file.icon" class=" text-2xl" [ngStyle]="{color:file.color}"></i>
                                    </td>
                                    <td style="text-wrap: break-word;">
                                        {{file.name}}
                                    </td>
                                    <td>
                                        <div class="flex  mx-auto align-items-center">
                                            <div class="text-red-500 cursor-pointer" (click)="deleteFile(i)">
                                                <i class="fa-solid fa-rectangle-xmark"></i>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                }
                            </ng-template>
                            <ng-template pTemplate="emptymessage" let-c>
                                <tr>
                                    <td class="text-center font-semibold text-lg " [attr.colspan]="7">
                                        {{'uploaded_any_files'|translate}}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        }@else {
                        <div class="text-center font-semibold text-lg">
                            {{'uploaded_any_files'|translate}}
                        </div>
                        }
                    </div>





                </div>
                <div class="mx-auto mt-5">

                    <div class="bg-yellow-50 text-white p-5  border-1 border-red-300 border-round-lg  mt-3">
                        <div class="flex align-items-center font-bold text-red-500 gap-3">

                            <i class="pi pi-exclamation-circle text-2xl text-red-500"></i>
                            <span class="text-center line-height-3">
                                {{'allowed_to_upload' | translate}}
                                {{selectedMileStone.left}}
                                {{'files_out_of' | translate}}
                                {{selectedMileStone.limit}},
                                {{'milstone_output_warning' | translate}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="flex gap-2">
                    <p-checkbox name="isUploadConfirmed" [(ngModel)]="isUploadConfirmed" [binary]="true"
                        inputId="binary" />
                    <p class="white-space-normal font-semibold">
                        {{'confirm_outcome_message'|translate}}
                    </p>

                </div>
            </div>
            <div class="mt-4">
                <p-button (onClick)="uploadOutput()" [disabled]="(!isUploadConfirmed || uploadedFilesCount==0)"
                    label=" {{'attach_output'|translate}}" icon="pi pi-file-arrow-up" type="submit" [raised]="true" />
            </div>
        </form>
    </div>
</div>
<div class="g-overlay"></div>
}

@if(isOutPutListModal){

<div class="h-screen pt-8  px-4 bg-white shadow-3  w-10 right-0 fixed  top-0  " style="z-index: 900;">
    <div class="pt-2 flex justify-content-between">
        <div>
        </div>
        <div (click)="closeOutputListModal()"
            class="w-2rem h-2rem bg-red-500 cursor-pointer  shadow-3 hover:bg-red-800   border-circle flex justify-content-center align-items-center">
            <i class="fa-solid fa-xmark text-white  "></i>
        </div>
    </div>
    <div class="text-center text-2xl font-bold">
        {{selectedMileStone.name}}
    </div>
    <div style="overflow-y: auto; max-height: calc(100vh - 10rem);">
        @if(outputList.length)
        {
        <div style="height: 100%;">
            <div class="relative">
                <div class="table pt-5 ">
                    <p-table [value]="outputList" [class]="dir" [tableStyle]="{ 'width': '70rem' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="text-align: center;">
                                    {{'file_name'|translate}}
                                </th>
                                <th style="text-align: center;">
                                    {{'notes'|translate}}
                                </th>
                                <th style="text-align: center;">
                                    {{"file_type"|translate}}
                                </th>
                                <th style="text-align: center;">
                                    {{"upload_date"|translate}}
                                </th>
                                <th style="text-align: center;">
                                    {{'approval_status'|translate}}
                                </th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-output>
                            <tr>
                                <td>
                                    <div class="white-space-nowrap overflow-hidden">
                                        {{output.file_name}}
                                    </div>
                                </td>
                                <td>
                                    <div class="white-space-nowrap overflow-hidden">
                                        {{output.comments}}
                                    </div>
                                </td>
                                <td>
                                    {{output.file_type}}
                                </td>
                                <td>
                                    {{output.created_at|date:'dd/MM/yyyy'}}
                                </td>
                                <td>
                                    @if(dir=='rtl'){
                                    @if(output.status=='approved'){
                                    <p-tag severity="success" value="معتمد" />
                                    }

                                    @if(output.status=='rejected'){
                                    <p-tag severity="danger" value="مرفوض" />
                                    }

                                    @if(output.status=='pending'){
                                    <p-tag severity="warning" value="قيد المراجعة" />
                                    }

                                    }@else{

                                    @if(output.status=='approved'){
                                    <p-tag severity="success" value="{{output.status}}" />
                                    }

                                    @if(output.status=='rejected'){
                                    <p-tag severity="danger" value="{{output.status}}" />
                                    }

                                    @if(output.status=='pending'){
                                    <p-tag severity="warning" value="{{output.status}}" />
                                    }
                                    }
                                </td>
                                <td>
                                    <div class="flex align-items-center gap-3">
                                        <div (click)="downloadOutput(output.id,output.milestone_id,output.file_name)">
                                            <p-button label=" {{'download'|translate}}" icon="pi pi-download"
                                                outlined="true" />
                                        </div>
                                        <div class="mr-4"
                                            (click)="confirmoutputDelete($event,output.milestone_id,output.id)">
                                            <p-button label="{{'delete'|translate}}" icon="pi pi-trash"
                                                severity="danger" outlined="true" />
                                        </div>

                                    </div>
                                    <p-confirmPopup baseZIndex="11000000" #deleteProof>
                                        <ng-template pTemplate="headless" let-message>
                                            <div class="border-round p-3">
                                                <span>
                                                    {{ message.message }}</span>
                                                <div class="flex align-items-center gap-2 mt-3">
                                                    <p-button (click)="accept()" label="{{'yes'|translate}}"
                                                        severity="danger"></p-button>
                                                    <p-button (click)="reject()" label="{{'no'|translate}}"
                                                        severity="secondary"></p-button>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </p-confirmPopup>

                                </td>

                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
        }@else{
        <div class="w-full h-full">
            <p class="font-bold text-center text-lg">
                {{'no_proofs'|translate}}
            </p>
        </div>
        }
    </div>
</div>
}









<ng-template #deleteMileStoneToolTip>
    <div class="flex align-items-center">
        <span>{{'delete_the_milestone' | translate}}</span>
    </div>
</ng-template>
<ng-template #updateMileStoneToolTip>
    <div class="flex align-items-center">
        <span>{{'edit_the_milestone' | translate}}</span>
    </div>
</ng-template>
<p-confirmPopup #confirmPopupRef>
    <ng-template pTemplate="headless" let-message let-test>
        <div class="border-round p-3">
            <span>
                {{ message.message }}</span>
            <div class="flex align-items-center gap-2 mt-3">
                <p-button (click)="accept()" label="نعم" severity="danger"></p-button>
                <p-button (click)="reject()" label="لا" severity="secondary"></p-button>
            </div>
        </div>
    </ng-template>
</p-confirmPopup>